import { useState, useEffect, useLayoutEffect } from 'react';
import { viewportHeight } from 'utils/helpers';

function usePageContainerMinHeight() {
  const [pageContainerMinHeight, setPageContainerMinHeight] = useState('0px');

  useEffect(() => {
    setPageContainerMinHeight(viewportHeight());
  }, []);

  useLayoutEffect(() => {
    const handleResize = () => {
      setPageContainerMinHeight(viewportHeight());
    };
    window.addEventListener('resize', handleResize);

    return (_) => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return `${pageContainerMinHeight}px`;
}

export default usePageContainerMinHeight;
